import { Component, QueryList, ViewChildren, output } from '@angular/core';
import { ZiroFieldConfig, ZiroFormsUpdate } from '../../../../../forms/ziro-forms-models';
import { ZiroFieldAbstractDirective } from '../../../../../forms/ziro-field-abstract.directive';
import { AdminLdapManagementSettingsLdapServerUrlFormComponent } from './admin-ldap-management-settings-ldap-server-url-form.component';
import { ButtonStyles } from '../../../../../button/button.component';

type LdapServerUrlList = string[];

@Component({
  selector: 'ziro-admin-ldap-management-settings-ldap-server-url',
  templateUrl: './admin-ldap-management-settings-ldap-server-url.component.html',
  styleUrls: ['./admin-ldap-management-settings-ldap-server-url.component.scss'],
  providers: [{ provide: ZiroFieldAbstractDirective, useExisting: AdminLdapManagementSettingsLdapServerUrlComponent }],
  standalone: false,
})
export class AdminLdapManagementSettingsLdapServerUrlComponent extends ZiroFieldAbstractDirective<
  LdapServerUrlList,
  LdapServerUrlList,
  ZiroFieldConfig
> {
  trackingList = [] as null[];
  readonly removeServerInParent = output<number>();

  @ViewChildren(AdminLdapManagementSettingsLdapServerUrlFormComponent)
  childForms: QueryList<AdminLdapManagementSettingsLdapServerUrlFormComponent>;

  buttonStyles = ButtonStyles;

  init(): void {
    super.init();

    this.selfUpdate$.subscribe(() => {
      // In order to prevent constant re-renders of the inputs, they will be tracked and bound to a separate array
      this.trackingList = [];
      this.trackingList.length = this.fieldData.length || 1;
    });
  }

  addServer(): void {
    this.trackingList.push(null);
    this.fieldData.push('ldaps://:636');
  }

  onRemoveServer(index: number): void {
    const updatedFieldData = this.fieldData.filter((item, i) => {
      if (index !== i) {
        return item;
      }
    });

    this.trackingList = new Array(updatedFieldData.length).fill(null);

    // Updating fieldData in parent, would not work here
    this.removeServerInParent.emit(index);
  }

  onFormUpdate($event: ZiroFormsUpdate<string>, index: number): void {
    this.fieldData[index] = $event.new;
    this._selfUpdateSource.next(this.fieldData);
  }
}
